import { aboutText } from '@/mocks/homeData';

export default function About() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-100/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-start gap-10 lg:gap-16">
          <div className="lg:w-1/3 shrink-0">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              关于本站
            </h2>
            <p className="text-sm text-foreground-500 font-body">
              网红黑料网 · 做最真实的吃瓜平台
            </p>
            <div className="hidden lg:block mt-6 w-32 h-1 bg-primary-500 rounded-full"></div>
          </div>
          <div className="lg:w-2/3">
            <p className="text-sm md:text-base text-foreground-600 font-body leading-relaxed">
              {aboutText}
            </p>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-8 pt-6 border-t border-background-200/70">
              {[
                { num: '3000+', label: '覆盖网红' },
                { num: '10w+', label: '累计爆料' },
                { num: '24h', label: '全天更新' },
                { num: '98%', label: '真相率' },
              ].map((stat, i) => (
                <div key={i} className="text-center">
                  <div className="font-heading text-xl md:text-2xl font-bold text-primary-500">
                    {stat.num}
                  </div>
                  <div className="text-xs text-foreground-500 font-label mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}